/**
 * Broadcast Store Module
 *
 * Manages broadcast messaging for bulk communication with segmented audiences.
 * Provides functionality to:
 * - Create, update, and delete scheduled broadcasts
 * - Target audiences with conditions and segments
 * - Test broadcasts with specific test users
 * - Estimate reach before sending
 * - Configure Facebook broadcast tags for compliance
 * - Manage broadcast selection and UI state
 *
 * @module store/modules/broadcast
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { BroadcastState } from "./types";
import { RootState } from "@/store/types";

const editor: Module<BroadcastState, RootState> = {
  // namespaced: true,
  getters,
  state,
  actions,
  mutations,
};

export default editor;
